import React from "react";
import logo from "../Assets/black-logo.png";
import { Link } from "react-router-dom";

function LogIn() {
  return (
    <div>
      <div>
        <img src={logo} alt="logo" className="h-20 block m-auto" />
        <hr />
      </div>

      <div className="m-auto py-6 px-4 sm:px-24 md:px-40 lg:w-[50rem]">
        <p className="font-semibold text-center">
          To continue, log in to Spotify.
        </p>
        <div className="grid gap-3 w-[100%] mt-2 lg:gap-y-3">
          <button className="bg-blue-600 text-white px-5 py-3 sm:py-3 md:py-3 rounded-3xl text-sm font-semibold uppercase border-[1px] border-transparent hover:border-black">
            <span className="space-x-2 flex justify-center items-center">
              <ion-icon name="logo-facebook"></ion-icon>
              <Link to="#">continue with facebook</Link>
            </span>
          </button>
          <button className="bg-black text-white px-5 py-3 sm:py-3 md:py-3 rounded-3xl border-[1px] text-sm font-semibold uppercase border-transparent hover:border-black">
            <Link to="#">continue with apple</Link>
          </button>
          <button className="text-gray-700 px-5 py-3 sm:py-3 md:py-3 rounded-3xl border-[1px] border-gray-400 text-sm font-semibold uppercase hover:border-black">
            <Link to="#">continue with google</Link>
          </button>
          <button className="text-gray-700 px-5 py-3 sm:py-3 md:py-3 rounded-3xl border-[1px] border-gray-400 text-sm font-semibold uppercase hover:border-black">
            <Link to="#">continue with phone number</Link>
          </button>
        </div>

        <div className="py-4">
          <fieldset className="border-t border-slate-300">
            <legend className="mx-auto px-3 font-medium">OR</legend>
          </fieldset>
        </div>

        <form className="w-full space-y-4">
          <div>
            <label className="block font-bold mb-1" htmlFor="inline-full-name">
              Email or username
            </label>
            <div className="mt-2">
              <input
                placeholder="Email or username"
                className="py-2 px-4 w-full font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
              />
            </div>
          </div>

          <div>
            <label className=" block font-bold mb-1" htmlFor="inline-full-name">
              Password
            </label>
            <div className="mt-2">
              <input
                placeholder="Password"
                className="py-2 px-4 w-full font-semibold placeholder:text-gray-700 rounded appearance-none border-[1px] border-gray-400"
              />
            </div>
          </div>

          <Link
            className="underline block font-medium text-base hover:text-green-500 transform duration-500 cursor-pointer "
            to="#"
          >
            Forgot your password?
          </Link>

          <div className="flex flex-row justify-between items-center py-2">
            <label className="font-bold">
              <input
                className="mr-2 leading-tight accent-green-400"
                type="checkbox"
              />
              <span className="text-sm">Remember me</span>
            </label>

            <button
              type="submit"
              className="hidden lg:inline px-8 py-3 sm:py-4 md:py-3 rounded-3xl bg-green-500 border-0 text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105 hover:bg-green-500 "
            >
              <Link to="#">log in</Link>
            </button>
          </div>
          <hr />
          <button
            type="submit"
            className="lg:hidden w-full px-5 py-3 sm:py-4 md:py-3 rounded-3xl bg-green-500 border-0 text-sm font-semibold uppercase hover:transform translate duration-800 hover:scale-105 hover:bg-green-500 "
          >
            <Link to="/login">log in</Link>
          </button>

          <div className="pt-3 space-y-4">
            <h1 className="font-bold text-center">Don't have an account?</h1>
            <button
              type="submit"
              className="w-full px-5 py-3 sm:py-4 md:py-3 rounded-3xl border-[1px] border-gray-400 text-sm text-gray-700 font-semibold uppercase"
            >
              <Link to="/signup">sign up for spotify</Link>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LogIn;
